import { __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { Routing, ModalUtils, Misc, AppServices } from '@singularsystems/neo-core';
import { inject, injectable } from 'inversify';
import { NeoReactTypes } from '../Modules/Types';
import { RoutingState } from './RoutingState';
var PageLeaveHandler = /** @class */ (function () {
    function PageLeaveHandler(routingState) {
        this.routingState = routingState;
    }
    /**
     * Handler for react-routers BrowserRouter.getUserConfirmation
     */
    PageLeaveHandler.showNavigationConfirmation = function (prompt, callback) {
        return __awaiter(this, void 0, void 0, function () {
            var pageLeaveHandler, routingState, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        pageLeaveHandler = Misc.Globals.appService.get(AppServices.NeoTypes.Routing.PageLeaveHandler), routingState = Misc.Globals.appService.get(NeoReactTypes.Routing.GlobalRoutingState);
                        return [4 /*yield*/, pageLeaveHandler.onLeavePage(routingState.currentView, prompt, Routing.NavigateLocation.Internal)];
                    case 1:
                        result = _a.sent();
                        callback(result);
                        return [2 /*return*/];
                }
            });
        });
    };
    PageLeaveHandler.prototype.onWindowUnload = function (view, e) {
        if (view) {
            var routeView = Misc.Globals.appService.get(NeoReactTypes.Routing.GlobalRoutingState).currentRouteView;
            var prompt_1 = routeView.beforeLocationChanged(undefined, "PUSH", true);
            if (prompt_1 || prompt_1 === false || prompt_1 === "") {
                e.preventDefault();
                e.returnValue = !prompt_1 ? "Are you sure you want to continue?" : prompt_1;
            }
        }
    };
    PageLeaveHandler.prototype.onLeavePage = function (view, prompt, location) {
        if (this.routingState.leavePromise) {
            var promise_1 = this.routingState.leavePromise;
            this.routingState.leavePromise = undefined;
            return new Promise(function (resolve) {
                promise_1.then(function (result) {
                    if (result) {
                        resolve(result === true || result === Misc.ModalResult.Yes);
                    }
                    else {
                        resolve(false);
                    }
                });
            });
        }
        else {
            return this.showDefaultConfirmation(view, prompt, location);
        }
    };
    PageLeaveHandler.prototype.showDefaultConfirmation = function (view, prompt, location) {
        var title = view ? view.viewName : "Un-saved Changes";
        return new Promise(function (resolve) {
            ModalUtils.showModal(title, prompt, {
                onClose: function () { return resolve(false); },
                acceptButton: { text: "Leave", onClick: function () { return resolve(true); } },
                closeButton: { text: "Stay", onClick: function () { return resolve(false); } }
            });
        });
    };
    PageLeaveHandler = __decorate([
        injectable(),
        __param(0, inject(NeoReactTypes.Routing.GlobalRoutingState.symbol)),
        __metadata("design:paramtypes", [RoutingState])
    ], PageLeaveHandler);
    return PageLeaveHandler;
}());
export { PageLeaveHandler };
